import { render, staticRenderFns } from "./WishListButton.vue?vue&type=template&id=2ea21dfb&scoped=true&"
import script from "./WishListButton.vue?vue&type=script&lang=js&"
export * from "./WishListButton.vue?vue&type=script&lang=js&"
import style0 from "./WishListButton.vue?vue&type=style&index=0&id=2ea21dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea21dfb",
  null
  
)

export default component.exports